export default function LoadingCard({ rows = 1 }: { rows?: number }) {
  return (
    <div className="mx-auto w-full max-w-sm p-4">
      <div className="flex animate-pulse space-x-4">
        <div className="w-full flex-1 space-y-6 py-1">
          {[...Array(rows)].map((_, idx) => (
            <div className="space-y-3" key={idx}>
              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-2 h-2 rounded bg-slate-200"></div>
                <div className="col-span-1 h-2 rounded bg-slate-200"></div>
              </div>
              <div className="h-2 rounded bg-slate-200"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function LoadingProductCard() {
  return (
    <div className="flex h-full animate-pulse cursor-pointer flex-col overflow-hidden rounded-[0.75rem] border border-[#D7DCE3] bg-white">
      <div className="relative">
        <div className="h-[7rem] w-full bg-slate-200 object-cover" />
      </div>
      <div className="flex flex-col space-y-2 px-2 py-4">
        <div className="h-5 w-20 rounded-[0.3125rem] bg-slate-200" />
        <div className="mt-2 h-4 w-3/4 rounded bg-slate-200" />
      </div>
    </div>
  );
}

export function LoadingSquare() {
  return (
    <div className="flex h-full animate-pulse cursor-pointer flex-col overflow-hidden rounded-[0.75rem] border border-[#D7DCE3] bg-white">
      <div className="relative h-full">
        <div className="absolute bottom-0 left-0 right-0 flex flex-col space-y-2 bg-white px-2 py-4">
          <div className="h-5 w-20 rounded-[0.3125rem] bg-slate-200" />
          <div className="mt-2 h-4 w-3/4 rounded bg-slate-200" />
          <div className="h-5 w-1/2 rounded-[0.3125rem] bg-slate-200" />
        </div>
      </div>
    </div>
  );
}
